function distributeProducts(weeklyPlan, breakfastItems, mainItems, snackItems) {
    const planResult = {};

    weeklyPlan.forEach(day => {
        planResult[day.title] = {
            breakfast: [],
            mains: [],
            snacks: []
        };

        if (breakfastItems.length > 0) {
            for (let i = 0; i < day.countBreakfast; i++) {
                planResult[day.title].breakfast.push(
                    {
                        id: breakfastItems[i % breakfastItems.length].ID,
                        quantity: breakfastItems[i % breakfastItems.length].count
                    }
                );
            }
        }

        if (mainItems.length > 0) {
            for (let i = 0; i < day.countMain; i++) {
                planResult[day.title].mains.push(
                    {
                        id: mainItems[i % mainItems.length].ID,
                        quantity: mainItems[i % mainItems.length].count
                    }
                );
            }
        }

        if (snackItems.length > 0) {
            for (let i = 0; i < day.countSnack; i++) {
                planResult[day.title].snacks.push(
                    {
                        id: snackItems[i % snackItems.length].ID,
                        quantity: snackItems[i % snackItems.length].count
                    }
                );
            }
        }

    });

    return planResult;
}

function getAllDishes(data, activeDay, allDays) {
    return data.filter((product, index) => {
        const totalProducts = data.length;
        const startIndex = (allDays * activeDay) % totalProducts;
        const endIndex = (allDays * (activeDay + 1)) % totalProducts;

        if (startIndex < endIndex) {
            return index >= startIndex && index < endIndex;
        } else {
            return index >= startIndex || index < endIndex;
        }
    });
}

function getActiveDay( weeklyPlan) {
    let activeDay = 0;
    weeklyPlan.forEach((day, i) => {
        if (day.view == true) {
            activeDay = i;
            return;
        }
    });

    return activeDay;
}

function getProductsInCard(products, days, menuCount) {
    let allSnacks = [];
    for (let i = 0; i < days; i++) {
        let dishes = getAllDishes(
            products,
            i,
            menuCount
        );

        allSnacks = [...allSnacks, ...dishes];
    }

    return allSnacks;
}

export { distributeProducts, getAllDishes, getActiveDay, getProductsInCard }